// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"6726a9f1","58":"6fd1af9a","76":"fd551bed","104":"a134844d","512":"2d15db6c","802":"08808948"}[chunkId] + ".css";
};